export interface IGroupAndCommercialVendorSearchRequest {
  region: string[];
  country: string[];
  groupReportingVendorName: string;  
}
